import type { DetailedPosition, Position } from '../types'

interface PositionCardProps {
  position: Position | DetailedPosition
}

export const PositionCard = ({ position }: PositionCardProps) => {
  // Check if this is a detailed position with sections
  const isDetailed = 'sections' in position
  const detailedPosition = position as DetailedPosition

  return (
    <div className="w-full pt-0">
      <p className="text-sm text-muted-foreground leading-relaxed mb-4">
        {position.description}
      </p>

      {isDetailed && detailedPosition.sections.length > 0 && (
        <div className="space-y-4">
          {detailedPosition.sections.map((section) => (
            <div key={section.id} className="space-y-2">
              <h4 className="text-sm font-medium capitalize">
                {section.header.replace(/_/g, ' ')}
              </h4>
              <div className="space-y-1">
                {section.items.map((item) => (
                  <p
                    key={item.id}
                    className="text-sm text-muted-foreground leading-relaxed"
                  >
                    {item.text}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
